import React, { Fragment } from 'react';
import { Grid, Typography, TextField, Button, SvgIcon } from '@material-ui/core';
import { FieldArray } from 'formik';
import { Plus, XCircle } from 'react-feather';

const AdditionalBorrowers = ({ location, values, handleChange, setFieldValue, disabled }) => {
  return (
    <>
      <FieldArray
        name={`${location}.additionalBorrowersModel`}
        render={(helper) => (
          values.additionalBorrowersModel.map((val, i) =>
            <Fragment key={`${location}-additionalBorrowersModel-${i}`}>
              <Grid item sm={12} md={2}>
                <Typography variant='body2'>Additional Borrower</Typography>
              </Grid>
              <Grid item md={4}>
                <TextField
                  label='First Name'
                  name={`${location}.additionalBorrowersModel[${i}].first_name`}
                  variant='outlined'
                  size='small'
                  fullWidth
                  value={val.first_name}
                  onChange={handleChange}
                  disabled={disabled}
                />
              </Grid>
              <Grid item md={4}>
                <TextField
                  label='Last Name'
                  name={`${location}.additionalBorrowersModel[${i}].last_name`}
                  variant='outlined'
                  size='small'
                  fullWidth
                  value={val.last_name}
                  onChange={handleChange}
                  disabled={disabled}
                />
              </Grid>
              { !disabled &&
                <Grid item md={2}>
                  <SvgIcon
                    fontSize='small'
                    color='primary'
                    onClick={() => helper.remove(i)}
                  >
                    <XCircle />
                  </SvgIcon>
                </Grid>
              }
            </Fragment>
          )
        )}
      />
      { !disabled &&
        <Grid item xs={12}>
          <Button
            color='primary'
            variant='contained'
            onClick={
              () => setFieldValue(`${location}.additionalBorrowersModel[${values.additionalBorrowersModel.length}]`, {
                first_name: '',
                last_name: ''
              })
            }
          >
            <SvgIcon fontSize='small'><Plus /></SvgIcon> Additional Borrower
          </Button>
        </Grid>
      }
    </>
  );
}

export { AdditionalBorrowers };
